import React, { useEffect, useState } from 'react'

import { useGetUsersQuery } from '@/features/users/usersApiSlice'

import EtImprintVision from '@/pages/home/web/userImprint/ImprintVisions/EtImprintVision'
import EtImprintMission from '@/pages/home/web/userImprint/ImprintMissions/EtImprintMission' // 23 Jun 2025
import EtImprintPlan from '@/pages/home/web/userImprint/ImprintPlans/EtImprintPlan' // 23 Jun 2025

// 23 Jun 2025
import EtImprintVisionIcon2SVGComp from '@/assets/img/icons/svgComp/EtImprintVisionIcon2SVGComp'
import EtImprintMissionsIcon1SVGComp from '@/assets/img/icons/svgComp/EtImprintMissionsIcon1SVGComp'
import EtImprintPlansIcon1SVGComp from '@/assets/img/icons/svgComp/EtImprintPlansIcon1SVGComp'


import { formatDateToMonthYear, formatDateToYear, formatDateTime, formatShortDate } from '@/utils/formatDate'
import { getTimeSince } from "@/utils/EtGetTimeSince"

const EtTrinitySetupVisionAndMissions = ({ userId="",userOrgId="", onClose }) => {
 
  // First Created - 23 May 2025
  // Author - Atul Pandey
  // Purpose - Prompt user to evaluate mission performance
  // Updated - 16 Jun 2025 - Added the main logic
  // Updated - 23 Jun 2025 - Added the Mission and Plan Tabs & refined the JSX to display these as Tabs


  // 1 - State variables
  const [activeTab, setActiveTab] = useState("vision");


  // 2 - Get Data
  const {data: usersData } = useGetUsersQuery()
  const userInfo = usersData?.ids.map(id => usersData?.entities[id])?.filter(user => user._id === userId)
  console.log('userInfo', userInfo)
  
  return (
    <div className="p-4">

      <div className='flex justify-between items-center m-1 p-1'>
          {/* <h3 className="text-lg font-bold text-gray-800 mb-2">Setup or Refine Your Vision & Missions </h3> */}
          <h3 className="text-lg font-bold text-gray-800 mb-2">Set your Roadmap of the Possible! </h3>
          <button
            onClick={onClose}
            className="text-sm text-blue-600 underline"
          >
            Close
          </button>
      </div>

      <div className="flex space-x-4 border-b border-orange-500 mb-4">
        {[
          { tab: "vision", label: "Vision", Icon: EtImprintVisionIcon2SVGComp },
          { tab: "mission", label: "Mission", Icon: EtImprintMissionsIcon1SVGComp },
          // { tab: "plan", label: "Plan", Icon: EtImprintPlansIcon1SVGComp }
        ].map(({ tab, label, Icon }) => (
          <button
            key={tab}
            onClick={() => setActiveTab(tab)}
            className={`flex items-center space-x-2 px-4 py-2 text-sm font-semibold border-b-2 ${
              activeTab === tab
                ? "border-orange-600 text-orange-600"
                : "border-transparent text-gray-500"
            }`}
          >
            <div
              className={`h-8 w-8 flex justify-center items-center rounded-full cursor-pointer ${
                activeTab === tab
                  ? "bg-gradient-to-r from-orange-600 to-orange-600 via-orange-800 hover:from-orange-400 hover:via-orange-600 hover:to-black shadow-lg shadow-black"
                  : "bg-gray-50 hover:bg-white"
              }`}
            >
              <Icon className={`h-6 w-6 ${activeTab === tab ? "text-white" : "text-orange-600"}`} />
            </div>
            <span>{label}</span>
          </button>
        ))}
      </div>
      
      {/* Tab Panels */}
      {activeTab === "vision" && (
        <EtImprintVision userId={userId} userInfo={userInfo} />
      )}
      {activeTab === "mission" && (
        <EtImprintMission userId={userId} userInfo={userInfo} />
      )}
      {activeTab === "plan" && (
        <EtImprintPlan userId={userId} userInfo={userInfo} />
      )}
     
      
    </div>
  );
}

export default EtTrinitySetupVisionAndMissions